<template>
  <!-- <div class="page-header">
      <h2>监测点位配置</h2>
      <div class="header-btn">
        <el-button type="primary" @click="openPointDialog">新增点位</el-button>
        <el-button @click="batchImport">批量导入</el-button>
        <el-button @click="batchExport">批量导出</el-button>
        <el-button type="warning" @click="openBatchThreshold"
          >批量阈值配置</el-button
        >
      </div>
    </div> -->

  <div class="page-body">
    <div class="row-two">
      <div class="col-tree">
        <div class="card-title">点位分类</div>
        <el-tree
          :data="pointTree"
          default-expand-all
          @node-click="treeClick"
          class="dark-tree"
        >
          <template #default="{ node, data }">
            <div class="tree-box">
              <div>
                {{ node.label }}
              </div>
              <div>
                <el-icon color="#f56c6c">
                  <Delete />
                </el-icon>
              </div>
            </div>
          </template>
        </el-tree>
        <el-button
          type="primary"
          @click="batchImport"
          style="position: absolute; bottom: 10px; width: calc(100% - 20px)"
          >新增分类</el-button
        >
      </div>

      <div class="col-table">
        <div class="search-bar">
          <el-input
            v-model="searchKey"
            placeholder="点位名称/编号"
            style="width: 240px"
          />
          <el-select v-model="searchType" placeholder="设备类型" clearable>
            <el-option label="GDS气体探测器" value="gds" />
            <el-option label="VOC监测设备" value="voc" />
            <el-option label="储罐液位仪" value="liquid" />
          </el-select>
          <el-button type="primary" @click="searchPoint">查询</el-button>
          <el-button type="primary" @click="openPointDialog"
            >新增点位</el-button
          >
          <el-button @click="batchImport">批量导入</el-button>
          <el-button @click="batchExport">批量导出</el-button>
          <el-button type="warning" @click="openBatchThreshold"
            >批量阈值配置</el-button
          >
        </div>

        <el-table
          :data="pointTable"
          border
          height="460px"
          class="data-table"
          style="margin-top: 12px"
        >
          <el-table-column type="selection" />
          <el-table-column label="点位编号" prop="code" />
          <el-table-column label="点位名称" prop="name" />
          <el-table-column label="设备类型" prop="type">
            <template #default="scope">
              <el-tag>
                {{
                  scope.row.type === "gds"
                    ? "GDS"
                    : scope.row.type === "voc"
                    ? "VOC"
                    : "液位仪"
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="采集协议" prop="protocol" />
          <el-table-column label="告警阈值" prop="threshold" />
          <el-table-column label="安装分区" prop="area" />
          <el-table-column label="状态" prop="status">
            <template #default="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                {{ scope.row.status ? "在线" : "离线" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-button size="small" @click="openPointDialog(scope.row)"
                >编辑</el-button
              >
              <el-button size="small" type="danger" @click="delPoint(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>

  <el-dialog
    v-model="pointDialogVisible"
    title="点位编辑"
    width="720px"
    class="dark-dialog"
  >
    <el-form :model="pointForm" label-width="110px">
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="点位编号">
            <el-input v-model="pointForm.code" />
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="点位名称">
            <el-input v-model="pointForm.name" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="设备类型">
            <el-select v-model="pointForm.type">
              <el-option label="GDS气体探测器" value="gds" />
              <el-option label="VOC监测设备" value="voc" />
              <el-option label="储罐液位仪" value="liquid" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="所属分区">
            <el-select v-model="pointForm.areaId">
              <el-option
                v-for="a in areaList"
                :key="a.id"
                :label="a.name"
                :value="a.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="采集协议">
            <el-select v-model="pointForm.protocol">
              <el-option label="MQTT" value="mqtt" />
              <el-option label="OPC UA" value="opcua" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="通讯地址">
            <el-input v-model="pointForm.addr" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="高告警阈值">
            <el-input-number v-model="pointForm.highThreshold" />
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="低告警阈值">
            <el-input-number v-model="pointForm.lowThreshold" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="设备备注">
        <el-input v-model="pointForm.remark" type="textarea" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="pointDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="savePoint">保存</el-button>
    </template>
  </el-dialog>

  <el-dialog
    v-model="batchThresholdVisible"
    title="批量配置告警阈值"
    width="600px"
    class="dark-dialog"
  >
    <el-form :model="batchForm" label-width="120px">
      <el-form-item label="批量高阈值">
        <el-input-number v-model="batchForm.high" />
      </el-form-item>
      <el-form-item label="批量低阈值">
        <el-input-number v-model="batchForm.low" />
      </el-form-item>
      <el-form-item label="应用范围">
        <el-radio-group v-model="batchForm.range">
          <el-radio label="all">当前筛选全部点位</el-radio>
          <el-radio label="selected">勾选选中点位</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="batchThresholdVisible = false">取消</el-button>
      <el-button type="primary" @click="saveBatchThreshold">批量应用</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="js">
import { ref, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete } from "@element-plus/icons-vue";
const pointTree = ref([
  {
    label: '气体监测类',
    children: [
      { label: 'GDS探测器', type: 'gds' }
    ]
  },
  {
    label: '废气监测类',
    children: [
      { label: 'VOC设备', type: 'voc' }
    ]
  },
  {
    label: '储罐监测类',
    children: [
      { label: '液位仪', type: 'liquid' }
    ]
  }
])

const treeClick = (node) => {}

const searchKey = ref('')
const searchType = ref('')
const page = ref(1)
const pointTotal = ref(86)

const areaList = ref([
  { id: 1, name: '一车间' },
  { id: 2, name: '储罐区' },
  { id: 3, name: '废气区' }
])

const pointTable = ref([
  {
    id: 1,
    code: 'GDS-001',
    name: '1#废气塔GDS',
    type: 'gds',
    protocol: 'MQTT',
    threshold: '低20 高80',
    area: '废气区',
    status: 1
  },
  {
    id: 2,
    code: 'VOC-003',
    name: '车间VOC探头',
    type: 'voc',
    protocol: 'OPC UA',
    threshold: '低10 高50',
    area: '一车间',
    status: 0
  }
])

const pointDialogVisible = ref(false)
const pointForm = reactive({
  id: '',
  code: '',
  name: '',
  type: '',
  areaId: '',
  protocol: 'mqtt',
  addr: '',
  highThreshold: 80,
  lowThreshold: 20,
  remark: ''
})

const openPointDialog = (row) => {
  if (row) {
    pointForm.id = row.id
    pointForm.code = row.code
    pointForm.name = row.name
    pointForm.type = row.type
    pointForm.areaId = row.areaId
    pointForm.protocol = row.protocol
    pointForm.addr = row.addr
    pointForm.highThreshold = row.highThreshold
    pointForm.lowThreshold = row.lowThreshold
    pointForm.remark = row.remark
  } else {
    pointForm.id = ''
    pointForm.code = ''
    pointForm.name = ''
    pointForm.type = ''
    pointForm.areaId = ''
    pointForm.protocol = 'mqtt'
    pointForm.addr = ''
    pointForm.highThreshold = 80
    pointForm.lowThreshold = 20
    pointForm.remark = ''
  }
  pointDialogVisible.value = true
}

const savePoint = () => {
  ElMessage.success('点位保存成功')
  pointDialogVisible.value = false
}

const delPoint = (row) => {
  ElMessageBox.confirm('确认删除该点位？').then(() => ElMessage.success('删除成功'))
}

const batchImport = () => ElMessage.info('打开文件导入弹窗')
const batchExport = () => ElMessage.success('导出文件已生成')

const batchThresholdVisible = ref(false)
const batchForm = reactive({
  high: 80,
  low: 20,
  range: 'all'
})

const openBatchThreshold = () => {
  batchThresholdVisible.value = true
}

const saveBatchThreshold = () => {
  ElMessage.success('批量阈值配置完成')
  batchThresholdVisible.value = false
}

const searchPoint = () => {}
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
  color: var(--text-main);
}

.page-body {
  background: var(--bg-card);
  border: 1px solid rgba(64, 158, 255, 0.22);
  border-radius: 6px;
  padding: 16px;
}

.row-two {
  display: flex;
  gap: 20px;
}

.col-tree {
  width: 240px;
  border-right: 1px solid rgba(64, 158, 255, 0.22);
  padding-right: 16px;
  position: relative;
  .tree-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.col-tree .card-title {
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 500;
  color: var(--text-main);
}

.col-table {
  flex: 1;
}

.search-bar {
  display: flex;
  gap: 12px;
  align-items: center;
}

.dark-pagination :deep(.el-pagination) {
  color: var(--text-sub);
}

.dark-dialog :deep(.el-dialog) {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
}

.dark-dialog :deep(.el-dialog__title) {
  color: var(--text-main);
}

.dark-dialog :deep(.el-form-item label) {
  color: var(--text-sub);
}
</style>
